export default function SecurityGroupViewDeleteModalController(
  $scope,
  $uibModalInstance,
  group,
  $state,
  securityGroupsService,
  gettextCatalog
) {
  'ngInject';

  $scope.group = group;
  $scope.loading = false;
  $scope.errorFlag = false;
  $scope.errorText = '';

  $scope.ok = function() {
    $scope.errorFlag = false;
    $scope.loading = true;
    securityGroupsService.deleteGroup($scope.group.id).then(
      function(response) {
        $uibModalInstance.close();
        $state.go('admin.securitygroups', {deleted: true});
      },
      function(error) {
        var errorMsg = gettextCatalog.getString('An error occurred while deleting the group');
        if (error.data || error.status) {
          if (error.data.message) {
            if (error.status && error.status === 403 && error.data.message === 'insufficient_scope') {
              errorMsg = gettextCatalog.getString('Not authorized to delete group.');
            } else {
              errorMsg = error.data.message + ' ' + (error.status.toString() + ' - ' + error.statusText.toString());
            }
          } else {
            errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        $scope.loading = false;
        $scope.errorText = errorMsg;
        $scope.errorFlag = true;
      }
    );
  };

  $scope.cancel = function() {
    $uibModalInstance.close('cancel');
  };

  $scope.$on('$locationChangeStart', function(event, next, current) {
    $scope.cancel();
  });
}
